export default __webpack_public_path__ + "static/media/tw-cross.badc66c5.png";